import styled, { css } from "styled-components"
import { fieldStyles } from "../styles"

export const StyledField = styled.input`
  ${fieldStyles};
  ${({ disabled }) =>
    !!disabled &&
    css`
      cursor: not-allowed;
    `}
`
export const Hint = styled.p`
  font-weight: 400;
  margin: 6px 0 0 5px;
  font-size: 0.9rem;

  p {
    font-size: 0.9rem;
  }
`
